import gql from 'graphql-tag';
import UserRecipeFragment from './fragments/UserRecipe';

export default gql`
  mutation updateRecipeInBox($input: UpdateRecipeInBoxInput!) {
    updateRecipeInBox(input: $input) {
      userRecipe {
        ...UserRecipeFragment
      }
    }
  }
  ${UserRecipeFragment}
`;
